import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-deny-time-off-request-dialog',
    templateUrl: './deny-time-off-request-dialog.html',
})
export class DenyTimeOffRequestDialogComponent {
    @Input() name: string;
    @Input() headerTitle: string;
    @Input() timeOffDates: string;
    @Input() primaryButtonLabel: string;
    @Input() extraText: string;
    @Input() hasExtraText = false;
    @Input() openDialog = false;
    @Input() maxlength = 200;

    @Output() confirmDenyRequest = new EventEmitter();
    @Output() closeDenyRequestModal = new EventEmitter();

    comment: string;

    onClose(): void {
        this.closeDenyRequestModal.emit();
    }

    onConfirm(): void {
        this.confirmDenyRequest.emit(this.comment);
    }
}
